import React, { useState } from "react";
import { Tooltip } from "antd";
import CustomModal from "../../components/common/CustomModal";
import {
  FiPlus,
  FiCalendar,
  FiClock,
  FiTag,
  FiChevronUp,
  FiChevronDown,
  FiHelpCircle,
} from "react-icons/fi";
import {
  FaEdit,
  FaEye,
  FaFire,
  FaBuilding,
  FaUserFriends,
  FaRegCheckCircle,
} from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Table from "../../components/Table";
import SelectDropdown from "../../components/common/SelectDropdown";
import Layout from "../../components/global/layout";
import methodModel from "../../methods/methods";
import shared from "./shared";
import { statusModel } from "../../models/Status.model";
import { AiFillPoundCircle } from "react-icons/ai";

function Html({
  sorting,
  filter,
  edit,
  view,
  statusChange,
  pageChange,
  count,
  deleteItem,
  clear,
  filters,
  setFilter,
  total,
  loaging,
  data,
  sortClass,
  hotPickChange,
  venues,
  changeVenue,
  changeStatus,
  selectedOffer,
  isModalVisible,
  closeModal,
}) {
  const user = useSelector((state) => state.user);
  const [isHelpModalVisible, setIsHelpModalVisible] = useState(false);

  const getStatusBadge = (status) => {
    switch (status) {
      case "active":
        return "bg-[#E5F9E6] text-[#00BF06] border-[#ADE6AF]";
      case "inactive":
        return "bg-[#ffefef] text-[#ff3b3b] border-[#ffa6a6]";
      case "expired":
        return "bg-red-50 text-red-500 border-red-200";
      default:
        return "bg-gray-100 text-gray-500 border-gray-200";
    }
  };

  const columns = [
    {
      key: "title",
      name: "Title",
      render: (row) => (
        <div className="flex items-center gap-3">
          {row.image ? (
            <img
              src={methodModel.noImg(row.image)}
              className="w-10 h-10 rounded-xl object-cover border border-gray-100 flex-shrink-0"
              alt={row.title}
            />
          ) : (
            <div className="w-10 h-10 rounded-xl bg-gray-50 border border-gray-100 flex items-center justify-center text-gray-400 text-lg flex-shrink-0">
              <FiTag />
            </div>
          )}
          <div className="flex flex-col min-w-0">
            <span className="font-semibold text-gray-900 text-sm whitespace-normal line-clamp-1">
              {(row.title || "")
                .toLowerCase()
                .replace(/\b\w/g, (char) => char.toUpperCase())}
            </span>
            <span className="text-xs text-gray-400 line-clamp-1 max-w-[250px]">
              {row.description || "No description"}
            </span>
          </div>
        </div>
      ),
    },
    {
      key: "venueId",
      name: "Venue",
      render: (row) => {
        const rawName = row.venue?.name || row.venue?.venueName || "N/A";
        const capitalizedName =
          rawName === "N/A"
            ? "N/A"
            : rawName
                .toLowerCase()
                .replace(/\b\w/g, (char) => char.toUpperCase());
        return (
          <div className="flex items-center gap-3 text-gray-600 font-medium text-sm">
            {row.venue?.logo ? (
              <img
                src={methodModel.noImg(row.venue.logo, "venue")}
                className="w-8 h-8 rounded-lg object-cover border border-gray-100 shadow-sm flex-shrink-0"
                alt={capitalizedName}
              />
            ) : (
              <div className="w-8 h-8 rounded-lg bg-amber-50 border border-amber-100 flex items-center justify-center text-[#CC9900] text-sm flex-shrink-0">
                <FaBuilding />
              </div>
            )}
            <span>{capitalizedName}</span>
          </div>
        );
      },
    },
    {
      key: "type",
      name: "Type",
      render: (row) => {
        let badgeStyle = "bg-blue-50 text-blue-600 border-blue-100";
        if (row.type === "percent_discount") {
          badgeStyle = "bg-amber-50 text-amber-600 border-amber-100";
        } else if (row.type === "free_item") {
          badgeStyle = "bg-green-50 text-green-600 border-green-100";
        }
        return (
          <span
            className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold capitalize border ${badgeStyle}`}
          >
            {row.type?.replace("_", " ")}
          </span>
        );
      },
    },
    {
      key: "value",
      name: "Value",
      render: (row) => (
        <span className="text-sm font-bold text-gray-800 bg-gray-50 border border-gray-100 px-2.5 py-1 rounded-lg">
          {row.type === "percent_discount"
            ? `${row.value}% OFF`
            : row?.value
              ? `£${row.value}`
              : `${row?.pointsRequired || 0} pts`}
        </span>
      ),
    },
    {
      key: "isHotPick",
      name: "Hot Pick",
      render: (row) => (
        <div
          className="cursor-pointer"
          onClick={() =>
            methodModel.hasPermission(user, shared.permissionKey, "edit") &&
            hotPickChange(row)
          }
        >
          <Tooltip
            title={
              methodModel.hasPermission(user, shared.permissionKey, "edit")
                ? row.isHotPick
                  ? "Remove from Hot Pick"
                  : "Make Hot Pick"
                : `You don't have specific permission!`
            }
          >
            <span
              className={`flex items-center justify-center w-9 h-9 rounded-xl border transition-all ${
                row.isHotPick
                  ? "bg-orange-50 text-orange-500 border-orange-200 shadow-sm scale-110"
                  : "bg-gray-50 text-gray-300 border-gray-100 hover:text-orange-400 hover:bg-orange-50 hover:border-orange-100"
              }`}
            >
              <FaFire className={row.isHotPick ? "animate-pulse" : ""} />
            </span>
          </Tooltip>
        </div>
      ),
    },
    {
      key: "status",
      name: "Status",
      render: (row) => (
        <div
          className="cursor-pointer"
          onClick={() =>
            methodModel.hasPermission(user, shared.permissionKey, "edit") &&
            statusChange(row)
          }
        >
          <span
            className={`w-fit text-xs px-3 py-1.5 flex items-center gap-1.5 border rounded-full capitalize font-semibold shadow-sm transition-all hover:opacity-90 ${getStatusBadge(row.status)}`}
          >
            <span
              className={`w-1.5 h-1.5 rounded-full ${
                row.status === "active"
                  ? "bg-[#00BF06]"
                  : row.status === "inactive"
                    ? "bg-[#ff3b3b]"
                    : "bg-red-500"
              }`}
            />
            {row.status}
          </span>
        </div>
      ),
    },
    {
      key: "action",
      name: "Action",
      render: (itm) => (
        <div className="flex items-center justify-start gap-2">
          <Tooltip placement="top" title="View Details">
            <a
              onClick={() => view(itm?._id || itm?.id)}
              className="cursor-pointer rounded-xl w-9 h-9 flex items-center justify-center text-sm transition-all bg-[#E5EFFD] text-[#005AEF] hover:bg-[#005AEF] hover:text-white shadow-sm"
            >
              <FaEye />
            </a>
          </Tooltip>

          {methodModel.hasPermission(user, shared.permissionKey, "delete") && (
            <Tooltip placement="top" title="Delete">
              <span
                onClick={() => deleteItem(itm?._id || itm?.id)}
                className="cursor-pointer rounded-xl w-9 h-9 flex items-center justify-center text-sm transition-all bg-[#F8E0DE] text-[#EE5B4F] hover:bg-[#EE5B4F] hover:text-white shadow-sm"
              >
                <MdDelete />
              </span>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  // Compute quick stats
  const activeOffersCount =
    data?.filter((itm) => itm.status === "active")?.length || 0;
  const hotPicksCount = data?.filter((itm) => itm.isHotPick)?.length || 0;

  return (
    <Layout>
      <div className="flex flex-wrap justify-between items-center gap-y-4 mb-6">
        <div>
          <h3 className="text-2xl font-bold text-[#111827]">
            Offers Management
          </h3>
          <p className="text-sm text-gray-500 mt-1">
            Manage promotions across all venues
          </p>
        </div>
      </div>

      {/* Quick Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {/* Total Offers Card */}
        <div className="bg-gradient-to-br from-white to-[#F9FAFB] p-5 rounded-2xl border border-gray-100 shadow-sm flex items-center gap-4 transition-all hover:shadow-md">
          <span className="w-12 h-12 rounded-xl bg-[#CC9900]/10 flex items-center justify-center text-[#CC9900] text-xl flex-shrink-0">
            <FiTag />
          </span>
          <div>
            <span className="text-xs text-gray-400 font-medium uppercase tracking-wider block">
              Total Offers
            </span>
            <h4 className="text-2xl font-bold text-gray-800 mt-1">
              {total || 0}
            </h4>
          </div>
        </div>

        {/* Active Offers Card */}
        <div className="bg-gradient-to-br from-white to-[#F9FAFB] p-5 rounded-2xl border border-gray-100 shadow-sm flex items-center gap-4 transition-all hover:shadow-md">
          <span className="w-12 h-12 rounded-xl bg-green-500/10 flex items-center justify-center text-green-600 text-xl flex-shrink-0">
            <FaRegCheckCircle />
          </span>
          <div>
            <span className="text-xs text-gray-400 font-medium uppercase tracking-wider block">
              Active Offers
            </span>
            <h4 className="text-2xl font-bold text-gray-800 mt-1">
              {activeOffersCount}
            </h4>
          </div>
        </div>

        {/* Hot Picks Card */}
        <div className="bg-gradient-to-br from-white to-[#F9FAFB] p-5 rounded-2xl border border-gray-100 shadow-sm flex items-center gap-4 transition-all hover:shadow-md">
          <span className="w-12 h-12 rounded-xl bg-orange-500/10 flex items-center justify-center text-orange-600 text-xl flex-shrink-0">
            <FaFire />
          </span>
          <div>
            <span className="text-xs text-gray-400 font-medium uppercase tracking-wider block">
              Hot Picks
            </span>
            <h4 className="text-2xl font-bold text-gray-800 mt-1">
              {hotPicksCount}
            </h4>
          </div>
        </div>
      </div>

      <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm">
        <div className="flex items-center flex-wrap gap-3 mb-6 w-full justify-between">
          {/* Search */}
          <form
            className="relative flex-1 max-sm:min-w-full min-w-[240px] max-w-sm"
            onSubmit={(e) => {
              e.preventDefault();
              filter();
            }}
          >
            <input
              type="text"
              value={filters.search}
              onChange={(e) => {
                setFilter({ ...filters, search: e.target.value });
                if (e.target.value === "") filter({ search: "" });
              }}
              className="bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-full focus:ring-[#CC9900] focus:border-[#CC9900] block w-full h-10 px-5 pr-11 transition-all outline-none"
              placeholder="Search offers..."
            />
            <button
              type="submit"
              className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#CC9900]"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m21 21-4.35-4.35M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
                />
              </svg>
            </button>
          </form>

          {/* Venue Filter */}
          <div className="max-sm:w-full flex gap-2 flex-wrap">
            <div className="max-sm:min-w-full min-w-[220px]">
              <SelectDropdown
                id="venueId"
                displayValue="name"
                placeholder="All Venues"
                theme="search"
                isClearable={true}
                intialValue={filters.venueId}
                result={(e) => {
                  changeVenue(e.value);
                }}
                options={venues.map((v) => ({
                  id: v._id || v.id,
                  name: v.name,
                  value: v._id || v.id,
                }))}
              />
            </div>

            {/* Status Filter */}
            <div className="max-sm:min-w-full min-w-[150px]">
              <SelectDropdown
                id="status"
                displayValue="name"
                placeholder="All Status"
                theme="search"
                isClearable={true}
                intialValue={filters.status}
                result={(e) => {
                  changeStatus(e.value);
                }}
                options={[
                  { id: "active", name: "Active", value: "active" },
                  { id: "inactive", name: "Inactive", value: "inactive" },
                  { id: "expired", name: "Expired", value: "expired" },
                ]}
              />
            </div>

            {/* Reset Button */}
            {(filters.search || filters.status || filters.venueId) && (
              <button
                onClick={() => clear()}
                className="bg-gray-100 hover:bg-gray-200 h-10 px-6 rounded-full text-sm font-semibold transition-colors text-gray-600"
              >
                Reset
              </button>
            )}
          </div>
        </div>

        {!loaging ? (
          <Table
            className="offer-table"
            data={data}
            columns={columns}
            page={filters.page}
            count={filters.count}
            filters={filters}
            total={total}
            result={(e) => {
              if (e.event === "page") pageChange(e.value);
              if (e.event === "sort") {
                sorting(e.value);
                sortClass(e.value);
              }
              if (e.event === "count") count(e.value);
            }}
          />
        ) : (
          <div className="py-20 text-center text-gray-400">
            Loading offers...
          </div>
        )}
      </div>

      <CustomModal open={isModalVisible} onClose={closeModal} width={650}>
        {selectedOffer && (
          <div className="flex flex-col bg-white rounded-2xl overflow-hidden font-sans">
            {/* Premium Gradient Header (Voucher Cap) */}
            <div className="bg-gradient-to-r from-[#CC9900] via-[#E6B800] to-[#CC9900] p-6 text-white relative">
              <div className="flex justify-between items-start gap-4">
                <div>
                  <h3 className="text-xl font-bold leading-snug">
                    {(selectedOffer.title || "")
                      .toLowerCase()
                      .replace(/\b\w/g, (char) => char.toUpperCase())}
                  </h3>
                  <div className="flex items-center gap-2 mt-2 text-white/90 text-xs font-medium">
                    {selectedOffer.venue?.logo ? (
                      <img
                        src={methodModel.noImg(
                          selectedOffer.venue.logo,
                          "venue",
                        )}
                        className="w-8 h-8 rounded-lg object-cover border border-white/20 shadow-sm flex-shrink-0"
                        alt="Venue Logo"
                      />
                    ) : (
                      <div className="w-8 h-8 rounded-lg bg-white/10 border border-white/20 flex items-center justify-center text-white text-sm flex-shrink-0">
                        <FaBuilding />
                      </div>
                    )}
                    <span>
                      {(() => {
                        const rawName =
                          selectedOffer.venue?.name ||
                          selectedOffer.venueId?.name ||
                          selectedOffer.venue?.venueName ||
                          "All Venues";
                        return rawName === "All Venues"
                          ? "All Venues"
                          : rawName
                              .toLowerCase()
                              .replace(/\b\w/g, (char) => char.toUpperCase());
                      })()}
                    </span>
                  </div>
                </div>
                <span
                  className={`text-[10px] px-3 py-1 rounded-full font-bold uppercase tracking-wider border bg-white/10 border-white/20 capitalize mr-8`}
                >
                  {selectedOffer.status}
                </span>
              </div>
            </div>

            {/* Ticket Dotted Separator */}
            <div className="relative bg-gray-50" style={{ height: "28px" }}>
              <svg
                className="absolute left-0 top-0 h-full"
                style={{ width: "14px" }}
                viewBox="0 0 14 28"
                preserveAspectRatio="none"
              >
                <path d="M0,0 C14,0 14,28 0,28 Z" fill="white" />
              </svg>
              <div
                className="absolute"
                style={{
                  top: "50%",
                  left: "14px",
                  right: "14px",
                  transform: "translateY(-50%)",
                  borderTop: "1.5px dashed #d1d5db",
                }}
              />
              <svg
                className="absolute right-0 top-0 h-full"
                style={{ width: "14px" }}
                viewBox="0 0 14 28"
                preserveAspectRatio="none"
              >
                <path d="M14,0 C0,0 0,28 14,28 Z" fill="white" />
              </svg>
            </div>

            {/* Modal Body */}
            <div className="p-6 space-y-6">
              {/* Offer Banner Image */}
              {selectedOffer.image && (
                <div className="relative rounded-2xl overflow-hidden border border-gray-100 shadow-sm max-h-48 flex items-center justify-center bg-gray-50">
                  <img
                    src={methodModel.noImg(selectedOffer.image)}
                    className="w-full max-h-48 object-cover"
                    alt={selectedOffer.title}
                  />
                </div>
              )}

              {/* Value Highlight */}
              <div className="bg-gradient-to-r from-amber-50 to-orange-50/30 border border-amber-100/60 rounded-2xl p-5 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="w-12 h-12 rounded-xl bg-[#CC9900]/10 flex items-center justify-center text-[#CC9900] text-xl">
                    <FiTag />
                  </span>
                  <div>
                    <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider block">
                      Offer Benefit
                    </span>
                    <span className="text-xs text-gray-500 capitalize">
                      {selectedOffer.type?.replace("_", " ")}
                    </span>
                  </div>
                </div>
                <h1 className="text-3xl font-black text-[#CC9900]">
                  {selectedOffer.type === "percent_discount"
                    ? `${selectedOffer.value}% OFF`
                    : selectedOffer.type === "free_item"
                      ? "FREE"
                      : selectedOffer?.value
                        ? `£${selectedOffer.value}`
                        : selectedOffer?.pointsRequired
                          ? `${selectedOffer.pointsRequired} pts`
                          : "Special"}
                </h1>
              </div>

              {/* Description */}
              <div>
                <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest block mb-2">
                  Description / Terms
                </span>
                <div className="text-gray-600 text-sm leading-relaxed bg-gray-50/70 p-4 rounded-2xl border border-gray-100/80">
                  {selectedOffer.description ||
                    "No description or specific terms provided for this promotion."}
                </div>
              </div>

              {/* Info Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Requirements */}
                <div className="bg-gray-50/50 rounded-2xl p-4 border border-gray-100/80">
                  <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest block mb-3">
                    Requirements
                  </span>
                  <div className="space-y-2.5">
                    <div className="flex items-center justify-between text-xs text-gray-600">
                      <span className="flex items-center gap-2">
                        <AiFillPoundCircle className="text-gray-400" />
                        Minimum Spend:
                      </span>
                      <span className="font-bold text-gray-900">
                        {selectedOffer.minSpend
                          ? `£${selectedOffer.minSpend}`
                          : "£0 (No Minimum)"}
                      </span>
                    </div>
                    {selectedOffer.pointsRequired > 0 && (
                      <div className="flex items-center justify-between text-xs text-gray-600">
                        <span className="flex items-center gap-2">
                          <FaUserFriends className="text-gray-400" />
                          Points Required:
                        </span>
                        <span className="font-bold text-gray-900">
                          {selectedOffer.pointsRequired} pts
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Availability / Timing */}
                <div className="bg-gray-50/50 rounded-2xl p-4 border border-gray-100/80">
                  <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest block mb-3">
                    Availability
                  </span>
                  <div className="space-y-3">
                    <div className="flex items-start gap-2.5 text-xs text-gray-600">
                      <FiCalendar className="text-[#CC9900] mt-0.5" />
                      <div className="flex flex-col">
                        <span className="text-[9px] text-gray-400 uppercase tracking-wider">
                          Validity Period
                        </span>
                        <span className="font-bold text-gray-800 mt-0.5">
                          {new Date(selectedOffer.validFrom).toLocaleDateString(
                            undefined,
                            { dateStyle: "medium" },
                          )}{" "}
                          -{" "}
                          {new Date(selectedOffer.validTill).toLocaleDateString(
                            undefined,
                            { dateStyle: "medium" },
                          )}
                        </span>
                      </div>
                    </div>
                    {selectedOffer.timeWindow?.start && (
                      <div className="flex items-start gap-2.5 text-xs text-gray-600">
                        <FiClock className="text-[#CC9900] mt-0.5" />
                        <div className="flex flex-col">
                          <span className="text-[9px] text-gray-400 uppercase tracking-wider">
                            Daily Hours
                          </span>
                          <span className="font-bold text-gray-800 mt-0.5">
                            {selectedOffer.timeWindow.start} -{" "}
                            {selectedOffer.timeWindow.end}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="bg-gray-50 px-6 py-4 border-t border-gray-100 flex justify-end gap-3">
              <button
                onClick={closeModal}
                className="px-5 py-2 rounded-xl border border-gray-200 text-gray-600 hover:bg-gray-100 transition-all text-xs font-semibold"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </CustomModal>

      {/* How It Works Guide Modal */}
      <CustomModal
        open={isHelpModalVisible}
        onClose={() => setIsHelpModalVisible(false)}
        width={650}
      >
        <div className="flex flex-col font-sans">
          {/* Premium Gradient Header */}
          <div className="bg-gradient-to-r from-[#CC9900] via-[#E6B800] to-[#CC9900] p-6 text-white relative">
            <div className="flex justify-between items-start gap-4">
              <div>
                <h3 className="text-xl font-bold leading-snug">
                  💡 How It Works: Hot Pick Promotions
                </h3>
                <p className="text-sm text-white/90 mt-1">
                  Learn how to feature your offers on the mobile application
                  home screen
                </p>
              </div>
            </div>
          </div>

          {/* Ticket Dotted Separator */}
          <div className="relative bg-gray-50" style={{ height: "28px" }}>
            <svg
              className="absolute left-0 top-0 h-full"
              style={{ width: "14px" }}
              viewBox="0 0 14 28"
              preserveAspectRatio="none"
            >
              <path d="M0,0 C14,0 14,28 0,28 Z" fill="white" />
            </svg>
            <div
              className="absolute"
              style={{
                top: "50%",
                left: "14px",
                right: "14px",
                transform: "translateY(-50%)",
                borderTop: "1.5px dashed #d1d5db",
              }}
            />
            <svg
              className="absolute right-0 top-0 h-full"
              style={{ width: "14px" }}
              viewBox="0 0 14 28"
              preserveAspectRatio="none"
            >
              <path d="M14,0 C0,0 0,28 14,28 Z" fill="white" />
            </svg>
          </div>

          {/* Modal Body */}
          <div className="p-6 space-y-6">
            <p className="text-sm text-gray-600 leading-relaxed">
              Promoting offers on the mobile app home screen slider banner helps
              attract more customers and boost engagement. Here is how it works:
            </p>

            <div className="space-y-4">
              {/* Step 1 */}
              <div className="flex gap-4 p-4 rounded-xl border border-gray-100 bg-gray-50/50">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-orange-50 text-orange-500 font-bold text-sm flex-shrink-0">
                  1
                </span>
                <div>
                  <h4 className="font-bold text-[#8B6E1E] text-sm mb-1">
                    Toggle Hot Pick Status
                  </h4>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    Locate the offer in the list and click the **Fire (🔥)**
                    icon under the **Hot Pick** column. Active Hot Pick offers
                    are indicated by a glowing orange background.
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex gap-4 p-4 rounded-xl border border-gray-100 bg-gray-50/50">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-yellow-50 text-yellow-600 font-bold text-sm flex-shrink-0">
                  2
                </span>
                <div>
                  <h4 className="font-bold text-[#8B6E1E] text-sm mb-1">
                    Instant App Slider Visibility
                  </h4>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    Any offer marked as a Hot Pick will **instantly become
                    visible on the slider banner** at the top of the mobile app
                    home screen.
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex gap-4 p-4 rounded-xl border border-gray-100 bg-gray-50/50">
                <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-green-50 text-green-600 font-bold text-sm flex-shrink-0">
                  3
                </span>
                <div>
                  <h4 className="font-bold text-[#8B6E1E] text-sm mb-1">
                    Attract & Convert Customers
                  </h4>
                  <p className="text-xs text-gray-600 leading-relaxed">
                    The top banner is the first thing customers see when they
                    open the app. Featuring your best offers here ensures
                    maximum visual attention and drives high engagement.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Modal Footer */}
          <div className="bg-gray-50 px-6 py-4 border-t border-gray-100 flex justify-end">
            <button
              onClick={() => setIsHelpModalVisible(false)}
              className="px-5 py-2 rounded-xl border border-gray-200 text-gray-600 hover:bg-gray-100 transition-all text-xs font-semibold"
            >
              Got it, thanks!
            </button>
          </div>
        </div>
      </CustomModal>

      {/* Floating Help Button */}
      <Tooltip placement="left" title="How It Works">
        <button
          type="button"
          onClick={() => setIsHelpModalVisible(true)}
          className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-12 h-12 rounded-full bg-[#CC9900] text-white shadow-lg hover:bg-[#B38000] hover:scale-110 active:scale-95 transition-all duration-300"
        >
          <FiHelpCircle className="text-2xl" />
        </button>
      </Tooltip>
    </Layout>
  );
}

export default Html;
